export const InsideColors = [
    {
        name: 'Natural Oak',
        code: '0125',
        url: 'Natural_Oak'
    },
    {
        name: 'Mango',
        code: '0010',
        url: 'Mango'
    },
    {
        name: 'Diabolo',
        code: '0012',
        url: 'Diabolo'
    },
    {
        name: 'Lamar',
        code: '0023',
        url: 'Lamar'
    },
    {
        name: 'Vivo',
        code: '0024',
        url: 'Vivo'
    },
    {
        name: 'Cognac Oak',
        code: '0048',
        url: 'Cognac_Oak'
    },
    {
        name: 'Pastel Grey',
        code: '0074',
        url: 'Pastel_Grey'
    },
    {
        name: 'Charcoal',
        code: '0077',
        url: 'Charcoal'
    },
    {
        name: 'Black',
        code: '0080',
        url: 'Black'
    },
    {
        name: 'White',
        code: '0085',
        url: 'White'
    },
    {
        name: 'Maple',
        code: '0102',
        url: 'Maple'
    },
    {
        name: 'Intensive Red',
        code: '0210',
        url: 'Intensive_Red'
    },
    {
        name: 'Arezzo',
        code: '0260',
        url: 'Arezzo'
    },
    {
        name: 'Delano',
        code: '0265',
        url: 'Delano'
    }
]
